import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { OnboardingService } from './onboarding.service';
import { OnboardingState } from './onboarding.state';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([OnboardingState])],
  providers: [OnboardingService],
  bootstrap: [],
  exports: [],
})
export class OnboardingStateModule {}
